import {INGXLoggerConfig, NgxLoggerLevel} from 'ngx-logger';
import {Injectable} from '@angular/core';

export enum SubdomainEnum {
  GP = 'gp',
  LP = 'invest'
}

@Injectable()
export class AppSettingsService {
  // The values that are defined here are the default values that can
  // be overridden by AppSettings.js
  public appSettignsLoaded = false;
  // public authUrl = 'http://localhost:11440/';
  public authUrl = 'https//localhost:44399/';
  // public resourceUrl = 'http://localhost:51400/api/';
  public resourceUrl = 'https//localhost:44302/api/';
  public debugTelemetry = false;
  public telemetryUrl = 'http://localhost:7072/api/Telemetry';
  public insightsUrl = 'http://localhost:7071/api/';
  public rankingUrl = 'http://localhost:7071/api/investors-ranking';
  // points to our Azure CDN endpoint for the Blob production storage endpoint
  public blobStorageUrlCDN = 'https://static.covercy.com/';
  public localEnv = false;
  public production = false;
  public maintenance = false;
  public mockData = true;
  public helloSignClientId = '8b8181a5d6e07a4f9eb31d1af37a71b2';

  public helloSignSkipDomainVerification = true;
  public contactsExampleFile = this.blobStorageUrlCDN + 'upload/contacts-example-import-file-july2020-2.csv';

  public googleAnalyticsTrackingCode = 'UA47135139-5';
  public googleTagManager = 'GTM-TCXB6LD';

  public fileStackApiKey = 'A23HMKiNbQpyM3ydPlV9Mz'; // staging

  public payAppFrontEnvironmentAppBaseUrl = 'https://localhost:4200/';
  public gpFrontEnvironmentAppBaseUrl = 'https://localhost:8200/';
  public lpFrontEnvironmentAppBaseUrl = 'https://localhost:6200/';
  public cookieDomainNamespace = 'localhost';

  public ssoGoogleClientId: string;
  public ssoFacebookClientId: string;

  public lpReferrerCookieKey: string = 'gpref';
  public gpReferrerCookieKey: string = 'gpref';

  public VGSVault = 'tntazhyknp1';
  public VGSEnvironment = 'sandbox';

  public verifyInvestorToken = 'test_only_I3TIFDj6YRwHNasWqyVAqg';

  public get mixpanelToken(): string {
    return this.subDomain === SubdomainEnum.GP
      ? '6ca0415ef9d001b3b6da830bffef1de7'
      : 'd7649920ad42f052d6688c9807cdc72e';
  }

  public recaptchaPublicKey = `6Ledn3cbAAAAAMQF5Ircknem3NYgkgM5eR4KMjmf`;
  public plaidEnvironment = 'sandbox';

  public isAutomation: boolean = false;
  public isTesting: boolean = false;

  public get subDomain(): SubdomainEnum {
    if (document.domain === 'localhost') {
      return location.port === '8200' ? SubdomainEnum.GP : SubdomainEnum.LP;
    }

    const subDomainSegment = this.getSanitizedSubDomain();
    return this.subDomainMap[subDomainSegment] ?? SubdomainEnum.LP; // Default to LP if no match
  }

  get isAutomationEnv() {
    return location.host.split('.')[0].toLowerCase() === 'automation-gp'
    || location.host.split('.')[0].toLowerCase() === 'automation-lp';
  }

  get isTestingEnv() {
    return location.host.split('.')[0].toLowerCase() === 'testing-gp'
    || location.host.split('.')[0].toLowerCase() === 'testing-lp';
  }

  get isGpDomain() {
    return this.subDomain === SubdomainEnum.GP;
  }

  get isLpDomain() {
    return this.subDomain === SubdomainEnum.LP;
  }

  private getSanitizedSubDomain(): string {
    return location.host.replace(/^www\./, '').split('.')[0].toLowerCase();
  }

   private subDomainMap: Record<string, SubdomainEnum> = {
    // Testing
    'testing-gp': SubdomainEnum.GP,
    'testing-lp': SubdomainEnum.LP,

    // Automation
    'automation-gp': SubdomainEnum.GP,
    'automation-lp': SubdomainEnum.LP,

    // Staging
    'gp8200': SubdomainEnum.GP,
    'lp6200': SubdomainEnum.LP,

    // Demo
    'demo-gp': SubdomainEnum.GP,
    'demo-investors': SubdomainEnum.LP,

    // Production
    'gp': SubdomainEnum.GP,
    'investors': SubdomainEnum.LP
};

  ngxLogging: INGXLoggerConfig = {
    level: NgxLoggerLevel.DEBUG,
    serverLogLevel: NgxLoggerLevel.ERROR
  };

  constructor() {
  }
}
